import { AuthApiClient } from "@/api/auth_client";
import { Route } from "vue-router";
import jwt from "jsonwebtoken";
import store from "@/store";

export const isLoggedIn = (): Promise<boolean> => {
  return new Promise<boolean>(resolve => {
    console.log(`Checking if the user is logged in or not...`);
    const authStore = store.state.auth;
    if (!authStore) resolve(false); // No auth information set

    const JWTs = authStore.jwts;
    if (!JWTs) resolve(false); // No JWTs set

    const JWT = JWTs.id_token;
    if (!JWT) resolve(false); // ID token not set
    if (!JWTs.refresh_token) resolve(false); // Refresh token not set

    console.log(`JWT data is set. Evaluating it...`);
    const decodedJWT = jwt.decode(JWT);

    const jwtExpiration = decodedJWT.exp || 0;
    const currentTime = Math.floor(Date.now() / 1000);

    if (currentTime > jwtExpiration) {
      console.log("JWT has expired. Trying to refresh the token...");
      const api = new AuthApiClient();

      api
        .refresh(JWTs)
        .then(response => {
          if (response.ok) {
            resolve(true);
          }
        })
        .finally(() => {
          resolve(false);
        });
    } else {
      resolve(true);
    }
  });
};

export const loggedInGuard = (to: Route, from: Route, next: Function) => {
  // If the user is logged in, they may continue.
  isLoggedIn().then(isUserLoggedIn => {
    if (isUserLoggedIn) {
      next();
    } else {
      next("/login");
    }
  });
};

export const loggedOutGuard = (to: Route, from: Route, next: Function) => {
  // If the user is logged _out_, they may continue.
  isLoggedIn().then(isUserLoggedIn => {
    if (isUserLoggedIn) {
      next("/home");
    } else {
      next();
    }
  });
};
